import { getSearchResultPageLink } from '@pkgs/components/index';
import { MarketCountryCode, type ErrorResult, type GetListingResponse, type Language } from '@pkgs/api';

const NOT_FOUND_PATH = '/404';
const autogenUrlRegex = /(\/[/A-Za-z-]+)/;

type GetListingErrorRedirectTargetParams = {
  listingResponse: ErrorResult<GetListingResponse, unknown>;
  countryCode?: MarketCountryCode;
  language: Language;
  queryString?: string;
};

const getAutogenListingRedirectTarget = ({ redirectUrl, queryString }: { redirectUrl: string; queryString?: string }) => {
  if (!autogenUrlRegex.test(redirectUrl)) {
    return;
  }

  return `${encodeURI(redirectUrl)}${queryString ? `?${queryString}` : ''}#showproperties`;
};

const toRelativeTarget = (target: string | URL) => {
  if (typeof target === 'string') {
    return target;
  }

  return `${target.pathname}${target.search}`;
};

export const getListingErrorRedirectTarget = ({
  listingResponse,
  countryCode,
  language,
  queryString,
}: GetListingErrorRedirectTargetParams) => {
  if (listingResponse.statusCode === 410) {
    if (listingResponse.data?.redirect?.url) {
      return (
        getAutogenListingRedirectTarget({
          redirectUrl: listingResponse.data.redirect.url,
          queryString,
        }) ?? NOT_FOUND_PATH
      );
    }

    return toRelativeTarget(
      getSearchResultPageLink({
        options: {
          countryCode: countryCode ?? MarketCountryCode.DE,
          language,
        },
        filters: {},
      }),
    );
  }

  return NOT_FOUND_PATH;
};
